import LangSwitcherEnum from '../enumerators/lang-switcher.enum'

export default class LangSwitcherComponent {
    constructor() {
        LangSwitcherComponent.onInit()
        LangSwitcherComponent.onClick()
        LangSwitcherComponent.openSelect()
    }

    static openSelect() {
        $(LangSwitcherEnum.LANG_SWITCHER).on('click', () => {
            $(LangSwitcherEnum.BODY).toggleClass('lang-switcher-active')
        })
    }

    static onInit() {
        const currentLanguage = LangSwitcherComponent.getGTCookie('googtrans').split('/').pop()
        if (currentLanguage) {
            const currentLanguageNamde = $(
                `[data-element="lang-switcher-item"][data-lang="${currentLanguage}"]`,
            )
            $(LangSwitcherEnum.LANG_SWITCHER).text(currentLanguageNamde.text())
            $(LangSwitcherEnum.LANG_SWITCHER_ITEM).removeClass('disable')
            currentLanguageNamde.addClass('disable')
        }
    }

    static onClick() {
        $(LangSwitcherEnum.LANG_SWITCHER_ITEM).on('click', function () {
            let selectedLangName = 'Français'
            const selectedLang = $(this).data('lang')
            $(LangSwitcherEnum.BODY).removeClass('lang-switcher-active')
            $(`#lang-switcher-trigger [data-gt-lang="${selectedLang}"]`)[0].click()

            if (selectedLang !== 'fr') {
                selectedLangName = $(this).text()
            }

            $(LangSwitcherEnum.LANG_SWITCHER).text(selectedLangName)

            setTimeout(() => {
                $(LangSwitcherEnum.LANG_SWITCHER_ITEM).removeClass('disable')
                $(`[data-element="lang-switcher-item"][data-lang="${selectedLang}"]`).addClass(
                    'disable',
                )
            }, 600)
        })
    }

    static getGTCookie(cname) {
        const name = `${cname}=`
        const decodedCookie = decodeURIComponent(document.cookie)
        const ca = decodedCookie.split(';')

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i]
            while (c.charAt(0) === ' ') {
                c = c.substring(1)
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length)
            }
        }

        return ''
    }
}
